/**
 * Redirects the browser to the shell in order to load the current page as a shell resource.
 * @param browserWindow
 */
export default function redirectToShell(browserWindow) {
    const systemBaseUri = `${browserWindow.location.protocol}//${browserWindow.location.host}`;
    browserWindow.location.href = systemBaseUri + "/shell/#" + encodeURIComponent(absolutePathOf(browserWindow.location));
}
function absolutePathOf(location) {
    return location.pathname
        + (location.search ? location.search : "")
        + (location.hash ? location.hash : "");
}
